import React from 'react';
import styled from 'styled-components';
import { colors } from '../../utils/theme';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const StyledLink = styled(Link)`
  color: ${colors.blackTwo};
  text-decoration: none;
`;

const LPLinkPlain = props => {
  const { hitServer, to } = props;
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = e => {
    const normalizedTo = typeof to === 'string' && !to.startsWith('/') ? `/${to}` : to;

    if (props.onClick) {
      props.onClick(e);
      return false;
    }
    if (hitServer) {
      e.preventDefault();
      window.location.assign(normalizedTo);
      return;
    }

    if (typeof normalizedTo === 'string' && location.pathname !== normalizedTo) {
      e.preventDefault();
      navigate(normalizedTo);
    }
  };

  return <StyledLink {...props} onClick={handleClick}></StyledLink>;
};

export default LPLinkPlain;
